export default "__VITE_ASSET__BumrioV2__"